import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ChartOptions } from 'src/app/shared/ChartOptions';
import { EGovAutomationDashboardClient } from 'src/app/web-api-client';

@Component({
  selector: 'app-egov-taxes-unpaid',
  templateUrl: './egov-taxes-unpaid.component.html',
  styleUrls: ['./egov-taxes-unpaid.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EGovTaxesUnpaidComponent implements OnInit, OnChanges {
  @Input() isRefreshed: boolean = false;
  @Input() startDate: string;
  @Input() endDate: string;

  public data: ChartOptions | any = {
    icon: 'alert-circle',
    tittle: 'Наредени суми по Такси',
    sale: '0.00 лв.'
  };
  public isLoading: boolean = true;

  constructor(
    private egovDashboardClient: EGovAutomationDashboardClient,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.loadData();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isRefreshed'] && !changes['isRefreshed'].firstChange) {
      this.loadData();
    }
    if ((changes['startDate'] || changes['endDate']) && !changes['startDate']?.firstChange && !changes['endDate']?.firstChange) {
      this.loadData();
    }
  }

  loadData(): void {
    this.isLoading = true;
    this.cdr.detectChanges();

    // Convert string dates to Date objects for API call
    const startDateTime = this.startDate ? new Date(this.startDate) : undefined;
    const endDateTime = this.endDate ? new Date(this.endDate) : undefined;

    this.egovDashboardClient.getTaxesUnpaid(startDateTime, endDateTime).subscribe(r => {
      const primary_color = localStorage.getItem('primary_color') || '#7366ff';

      this.data = {
        data: [],
        series: [
          {
            name: 'Неплатени Такси',
            data: r.totalByMonth
          },
          {
            name: 'Неплатени Такси',
            data: r.totalByMonth,
          },
        ],
        chart: {
          type: 'bar',
          height: 100,
          stacked: true,
          stackType: '100%',
          toolbar: {
            show: false,
          },
        },
        plotOptions: {
          bar: {
            horizontal: false,
            columnWidth: '40px',
            borderRadius: 2,
          },
        },
        grid: {
          show: false,
          xaxis: {
            lines: {
              show: false,
            },
          },
        },
        states: {
          hover: {
            filter: {
              type: 'darken',
              value: 1,
            },
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        colors: [primary_color, '#dad8e0'],
        xaxis: {
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          axisTicks: {
            show: false,
          },
        },
        yaxis: {
          labels: {
            show: false,
          },
        },
        tooltip: {
          marker: {
            show: false,
          },
          fixed: {
            enabled: false,
            position: 'bottomRight',
            offsetX: 0,
            offsetY: 0,
          },
        },
        responsive: [
          {
            breakpoint: 1661,
            options: {
              chart: {
                width: 80,
              },
            },
          },
          {
            breakpoint: 1365,
            options: {
              chart: {
                width: 80,
              },
            },
          },
        ],
        tittle: 'Наредени суми по Такси',
        icon: 'alert-circle',
        sale: r.total.toFixed(2) + ' лв.',
      };

      this.isLoading = false;
      this.cdr.detectChanges();
    });
  }
}

